// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import BootstrapVue from 'bootstrap-vue'
import { GridInstaller } from '@progress/kendo-grid-vue-wrapper'
import { DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper'
import { InputsInstaller } from '@progress/kendo-inputs-vue-wrapper'
import { KendoPopupsInstaller } from '@progress/kendo-popups-vue-wrapper'
import { ChartInstaller } from '@progress/kendo-charts-vue-wrapper'
import { DropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper'
import { DateinputsInstaller } from '@progress/kendo-dateinputs-vue-wrapper'
import { DialogInstaller } from '@progress/kendo-dialog-vue-wrapper'
import { PivotGridInstaller } from '@progress/kendo-pivotgrid-vue-wrapper'
import NProgress from 'vue-nprogress'

Vue.use(NProgress)
const nprogress = new NProgress({ parent: '.nprogress-container' })
// setup axios
axios.interceptors.request.use(function (config) {
  config.url = process.env.API_SERVER + config.url
  var token = localStorage.getItem('token')
  nprogress.start()
  if (token === null || typeof (token) === 'undefined') {
    config.headers = {
      'Authorization': 'Basic ' + process.env.API_KEY
    }
  } else {
    token = JSON.parse(token)
    config.headers = {
      'Authorization': 'Bearer ' + token.access_token
    }
  }
  return config
})
axios.interceptors.response.use(
  (response) => {
    nprogress.done()
    return response
  },
  (error) => {
    nprogress.done()
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.clear()
      window.location.href = '/#/login'
    }
    return error
  }
)
Vue.use(VueAxios, axios)

// include vue-meta
Vue.use(VueMeta)

// bootstrap
Vue.use(BootstrapVue)

// load widget
Vue.use(GridInstaller)
Vue.use(DataSourceInstaller)
Vue.use(InputsInstaller)
Vue.use(KendoPopupsInstaller)
Vue.use(ChartInstaller)
Vue.use(DropdownsInstaller)
Vue.use(DateinputsInstaller)
Vue.use(DialogInstaller)
Vue.use(PivotGridInstaller)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js